import React, {useState} from 'react'
import { observer } from 'mobx-react-lite'
import DraftCommentModal from './DraftCommentModal'

export default observer(function CommentLocationMark({ location, goToCommentTime }) {
  const [openComments, setOpenComments] = useState(false)

  return (
    <div
      className='overflow-x-visible'
      style={{
        position: 'absolute',
        top: `${location.top - 40}px`,
        left: `${location.left}px`,
      }}
    >
      <div className="relative overflow-x-visible">
        <button
          type='button'
          className='absolute h-10 w-10 z-10 border-2 border-rb-green rounded-full'
          style={{
            backgroundColor: '#2D3332',
          }}
          onClick={(e) => {
            e.stopPropagation()
            setOpenComments(!openComments)
          }}
        >
          <div
            className='absolute -z-1 w-[23px] h-[23px] top-[15px] -left-[2px] border-l-2 border-b-2 border-rb-green rounded-bl-md'
            style={{
              backgroundColor: '#2D3332',
            }}
          />
          <img src={location.locationOwnerAvatar} alt={location.locationOwnerName} className='w-8 h-8 rounded-full absolute top-2/4 left-2/4 transform -translate-x-1/2 -translate-y-1/2 object-cover'/>
        </button>
        {
          openComments && (
            <DraftCommentModal
              isOpen={openComments}
              onClose={(e) => {
                e.stopPropagation()
                setOpenComments(false)
              }}
              location={location}
              goToCommentTime={goToCommentTime}
            />
          )
        }
      </div>
    </div>
  )
})
